// extracted by mini-css-extract-plugin
module.exports = {"IAndCLifecycleComponents":"IAndCLifecycleComponents_IAndCLifecycleComponents___AR4G"};